var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lottie-spinner-overlay is-flex is-align-items-center is-justify-content-center is-flex-direction-column"},[_c('div',{ref:"lottie",staticClass:"lottie-spinner"}),_c('div',{staticClass:"has-text-white mt-1"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }